import React from "react";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

class SelectCategory extends React.Component {
    // constructor(props) {
    //     super(props);
    // }

    render() {
        // console.log("SelectCategory selection:", this.props.selection, ", categories:", this.props.categories);
        let categories = this.props.categories;
        let selection = this.props.selection || (categories.length > 0 ? categories[0] : null);

        return <Select
            id="selected"
            className="select"
            value={selection || ''}
            onChange={e => this.props.onSelect(this.props.id, e.target.value)}
        >
            {
                categories.map((category) => {
                    return (
                        <MenuItem key={category.id} value={category}>{category.name}</MenuItem>
                    );
                })
            }
        </Select>;
    }
}

export default SelectCategory;

